<template>

  <router-link
    v-if="to"
    :to="to"
    :disabled="disabled"
  >
    <slot></slot>
  </router-link>

  <button
    v-else
    ref="rootRef"
    :disabled="disabled"
    @click.capture="rippleClick"
  >
    <slot></slot>
  </button>

</template>


<script>

export default {
  name: "RpmButtonDynamicTag",
  props: {
    to: {
      type: [String, Object],
      default: null
    },
    noRipple: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    rippleClick(event) {
      if(!this.noRipple){
        let overlay = document.createElement('span');
        overlay.classList = 'ripple';

        this.$refs.rootRef.appendChild(overlay);

        const rect = this.$refs.rootRef.getBoundingClientRect();
        overlay.style.top = `${event.clientY - rect.y}px`;
        overlay.style.left = `${event.clientX - rect.x}px`;

        setTimeout(() => {
          try {
            this.$refs.rootRef.removeChild(overlay);
          } catch (error) {}
        }, 500);
      }
    }
  },
};

</script>
